import './customCard.scss';

const CustomCard = ({ children, style, height=400, width=400 }) => {
    return (
        <div className="custom-card" style={{ ...style, height: height, width: width }}>{children}</div>
    )
}

export default CustomCard;  